export default "__VITE_ASSET__DRQU$txE__";